import axios from "./axios";

class Routes {
  async fetch_data_history(country, startDate, endDate) {
    const response = await axios.get(`/fetch_data_history`, {
      params: { country, startDate, endDate }
    });
    if (response && response.response?.data) return response.response.data;
    return response.data;
  }
}

export default new Routes(); 